export type EmailData = {
  type: string | null;
  email: string;
};
